import { AEMOptions, AEMPageType } from "@AEM/models/AEMPage.model"
import { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"
import { AEMIcon } from "@AEM/models/AEMResponse.model"
import { createItemsArrayMapper } from "@AEM/AEMContentMapper"

export const useAEMAvatars = () => {
	const queryParams = { queryParams: { path: "avatars" } } as AEMOptions
	const {
		data: avatars,
		isLoading,
		error,
		refetch
	} = useAEMContent(AEMPageType.ICONS, {
		mapper: createItemsArrayMapper(),
		...queryParams
	}) as UseQueryResult<AEMIcon[]>

	return { avatars, isLoading, error, refetch }
}
